<div class="row enrollement-page">
    <div class="col padding-page" [ngClass]="{ 'enrollement-page-container': enrollPolicyId }">
        <div class="border-bottom-grey" [ngClass]="{ 'no-border-grey': !enrollPolicyId }">
        <ng-container *ngIf="!enrollPolicyId">
            <h2 class="title title-paperless-enrollment" >
                AAA Insurance Paperless Program-Terms and Conditions 
            </h2>
            <div class="inline-block additional-padding mt-4">
                
                <p class="float-right">
                    <span>
                        Revised: August 23, 2023 
                    </span>
                </p>
             </div> 
       </ng-container>
         <ng-container *ngFor="let policy of policyDetails"> 
            <ng-container *ngIf="policy?.policynumber.policyNumber === enrollPolicyId">
                <h2 class="title title-paperless-enrollment" >
                    Please confirm your request to enroll policy {{ enrollPolicyId}} in paperless
                </h2> 
                <div class="inline-block additional-padding">
                    <p class="bold-text margin-top mt24 fs-16">
                        AAA Insurance Paperless Program-Terms and Conditions
                    </p>
                    <p class="float-right">
                         <span>
                            Revised: August 23, 2023 
                        </span>
                    </p>
                </div>
            </ng-container>
           
        </ng-container>
      <div class="additional-padding">
        <div class="padding-bottom pb24">
        <p class="bold-text">
            Please read these Terms and Conditions carefully. By voluntarily opting-in to electronic delivery 
            of notices and documents through our paperless program, you are affirmatively consenting to these 
            terms and conditions. If you disagree with these terms and conditions, please select no.
        </p>

        <p>These Terms and Conditions may change from time to time, we will email you with any revision.</p>

        <p>
             <strong>Hardware and Software Requirements:</strong>
            You will need access to the Internet and a valid email account. You will need Adobe Acrobat Reader version 8.0 or greater to download documents on our website. Documents are viewable only through your browser. 
        </p>

        <p>
            AAA Insurance will inform you of any changes to these hardware and software requirements.
            You will need to review the new requirements and contact us if such changes cause you to lose the 
            ability to access or retain your electronic insurance documents.
        </p>

        <p>
            <strong> Your Obligations:</strong> You must inform us of any changes to your email address,
            as well as keeping your email address active and capable of receiving new emails. 
            Your email address can be updated in the Customer Portal <strong class="url">(https://myaccount.Insure.WA.AAA.com/) </strong>
            any time. We are not responsible for issues arising due to emails sent to inactive or out-of-date 
            email address, unless we are solely negligent for using an incorrect address.
        </p>

        <p> 
            <strong>Your Consent:</strong> Your consent to these terms and conditions confirms that you are
            consenting to receive all policies, endorsements, invoices, notices and/or documents from us electronically, 
            including notice of nonrenewal and cancellation. However, there may be some documents that we continue 
            to send via mail due to legal or technological constraints. 
         </p>

           <p> <strong>Paperless Program Details:</strong> You will receive electronic document delivery email notifications. Your receipt of these email notifications constitutes delivery of all documents available for 
            you to securely access and view on our website. 
            You will be able to view, download and/or print any document or documents of your choosing. 
            You can access your documents from the Customer Portal <strong class="url">(https://myaccount.Insure.WA.AAA.com/)</strong> by 
            selecting “Billing, Policy & Documents”.
            </p>

        <p class="last-p">You do have the right to request any of these documents in paper by contacting 
            our service department at 1-844-295-4500. Withdrawal of Consent: You can opt-out of paperless at any time 
            through the Customer Portal 
            <strong class="url">(https://myaccount.Insure.WA.AAA.com/).</strong>
        </p>
        
        </div>
        <ng-container *ngFor="let policy of policyDetails">
            <ng-container *ngIf="policy?.policynumber.policyNumber === enrollPolicyId">
                <div class="padding-top pt24 teblet-mob">
                <p>
                   
                    <input class="single-checkbox ng-untouched ng-valid ng-dirty" type="checkbox" id="paperless-legal-checkbox" required  (change)="checkValue()"  >
                    <label for="paperless-legal-checkbox" class="legal disclaimer small ppl-enr-disclaimer" >I consent to receive all policies, endorsements, invoices, notices and other documents electronically
                    from AAA insurance, subject to the terms and conditions stated above.</label>
                </p>
                </div>
            </ng-container>
        </ng-container>

        </div>
    </div>
    
            <ng-container *ngFor="let policy of policyDetails">
        <ng-container *ngIf="policy?.policynumber.policyNumber === enrollPolicyId">
            <div class="display-flex-allign mx-auto text-center margin-vertical mv24">
                
                <div class="inline-block no-border-radius  btn-terms">
                    
                    <mapfre-button
                   
                    [disabledValue]="chkAcceptTerms" 
                    (click)="callEnrolldata(policy, 'e-policy')"
                        additionalClasses="basic primary {{chkAcceptTerms}}  medium-btn toUpperCase"
                       
                    >
                        {{ "CONFIRM_ENROLLMENT" | translate }}
                    </mapfre-button>
                    
                    </div>
                <div class="inline-block margin-right mr24 btn-terms">
                    <mapfre-button
                        additionalClasses="ghost secondary medium-btn no-border-radius"
                        (click)="goTopaperless()"    
                    >
                        {{ "CANCEL" | translate }}
                    </mapfre-button>
                    </div>
               
                
                <router-outlet></router-outlet>
                </div>
            </ng-container>
            </ng-container>
                <div class="col allign-center padding-vertical pv24" >
                    <mapfre-button
                    (click)="goTopaperless()"
                    additionalClasses="link-button small-btn blue-link no-margin button-border-red"
                    [backIcon]="'assets/img/icons/back-arrow-red.png'"
                    [iconClasses]="'align-middle'"
                    [showIconsCustom]="true"
                    >
                    {{ "BACK" | translate }}
                    </mapfre-button>
                </div>
</div>
</div>